export const ANNOTATIONS_TEMPLATES_URL = '/#/config/annotations-templates'

export const API_TEMPLATES_URL = '/services/plugin-annotations-templates/annotations-templates'

export const ANNOTATIONS_URL = '/services/plugin-annotations/annotations'

export const API_ADVANCED_ANNOTATIONS_URL = '/services/plugin-annotations-templates/advanced-annotations'

export const CONTAINER_DEDUCTION = 71
